import src from "IMAGE";
export default { src, width: 1300, height: 292, blurWidth: 0, blurHeight: 0};
